import { Helmet } from "react-helmet-async";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

const Waivers = () => {
  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <Helmet>
        <title>Liability Waiver | Son's Guadalupe</title>
        <meta name="description" content="Complete your waiver for Son's Guadalupe activities. Sign your liability waiver before your visit." />
      </Helmet>

      <Header />

      {/* Waiver Container - Full page iframe */}
      <main className="flex-1 w-full max-w-7xl mx-auto pt-32 lg:pt-40 pb-8 px-4">
        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <iframe
            name="checkfront"
            className="CHECKFRONT_DROPLET"
            src="https://sonsguadalupe.checkfront.com/reserve/document/?template_id=1&return_url=%2Freserve%2Fdocuments%2Fdirectory%2F&kiosk=1/?inline=1&provider=droplet&pipe=https%3A%2F%2Fsonsguadalupe.checkfront.com%2Fmanage%2Fextend%2Fintegrate%2Fwidget%2Fdroplet%2Fpipe%2Fhelper.html&ssl=1&src=https%3A%2F%2Fsonsguadalupe.checkfront.com"
            style={{
              display: 'block',
              width: '100%',
              height: 'calc(100vh - 220px)',
              minHeight: '600px',
              border: 'none',
            }}
            title="Waiver Form"
          />
        </div>
        
        {/* Help text */}
        <p className="text-center text-charcoal/60 text-sm mt-4">
          Need help? Call{" "}
          <a href="tel:877-577-7667" className="text-teal font-medium hover:underline">
            877-577-7667
          </a>
          {" "}(9am-7pm Daily)
        </p>
      </main>

      <Footer />
    </div>
  );
};

export default Waivers;
